import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'catalogos/categorias-de-pagos-de-convenios/';
/**
 * GET Categorias De Pagos
 * @returns {Promise<Array<object>>}
 */
export const getCategoriasDePagos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * GET Categoria De Pagos
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCategoriaDePagos = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};
/**
 * POST Categoria De Pagos
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCategoriaDePagos = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * PATCH Categoria De Pagos
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCategoriaDePagos = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Categoria De Pagos
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCategoriaDePagos = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
